// extracted by mini-css-extract-plugin
export var container = "FlipCards-module--container--eE5u+";